import React, { useState, useEffect } from 'react';
import '../Servicios/Servicios.css';
import img1 from '../../img/Servicios/fondo/2.JPG';
import img3 from '../../img/Servicios/fondo/1.jpg';
import logo from '../../img/Logo/tmologo.png';
import { Link } from "react-router-dom";
import esr from '../../img/Certificaciones/Empresasocialmenteresponsable.png';
import prod1 from '../../img/Productos/canastillas.jpg';
import prod3 from '../../img/Servicios/Productos/Remolque 2.jpg';
import pren75 from '../../img/Servicios/Equipo/Prensa75.jpg'
import pre150 from '../../img/Servicios/Equipo/Prensa150.jpg'
import prensa110 from '../../img/Servicios/Equipo/prensa110.jpg'
import pren60 from '../../img/Servicios/Equipo/Prensa60.jpg'
import pren63 from '../../img/Servicios/Equipo/Prensa63.jpg'
import doblamina from '../../img/Servicios/Equipo/dobladora-lamina.jpg'
import cortubo from '../../img/Servicios/Equipo/dobladora-tubo.jpg'
import dobtubo from '../../img/Servicios/Equipo/cortadora de tubo.jpg'
import lamina from '../../img/Servicios/Equipo/Lamina R-101.jpg'
import cnchaas from '../../img/Servicios/Equipo/CNCHAAS.jpg'
import robot from '../../img/Servicios/Equipo/robot.jpg'
import metalera from '../../img/Servicios/Equipo/metalera.jpg'
import desc150 from '../../img/Servicios/back/Prensa 150.png'
import desc110 from '../../img/Servicios/back/Prensa 110.png'
import desc75 from '../../img/Servicios/back/Prensa 75.png'
import desc60 from '../../img/Servicios/back/Prensa 60.png'
import desc63 from '../../img/Servicios/back/Prensa 63.png'
import descdob from '../../img/Servicios/back/Dobladora.png'
import deschaas from '../../img/Servicios/back/CNC HAAS.png'
import descort from '../../img/Servicios/back/Cortadora.png'
import pre800 from '../../img/Servicios/back/Prensa800.png'
import cortcnc from '../../img/Servicios/back/cortcnc.png'
import geka from '../../img/Servicios/back/GEKA.png'
import roseta from '../../img/Nosotros/Fondo/Roseta gift.gif'
import vidservicios from '../../img/Servicios/Servicios TMO_1.mov';

import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import zincado from '../../img/Servicios/zincado.JPEG';
import laser from '../../img/Servicios/cortelaser.png';
import manual from '../../img/Servicios/manual.JPEG';
import cortetub from '../../img/Servicios/cortubo.JPG';
import pren800 from '../../img/Servicios/pren800.jpg';
import raks from '../../img/Servicios/Productos/Rack estante.jpg';
import doblatubo from '../../img/Servicios/Dobladora de tubo.png';
import estruc from '../../img/Servicios/estructuras.jpg';
import aviso from '../doc/Aviso de Privacidad TMO.pdf'
import termino from '../doc/Terminos y Condiciones TMO.pdf'

const fondoSecuencial = [img1, img3];
const palabras = ['Productos', 'Servicios', 'Equipo'];

const Servicios = () => {
    const [imageToShow, setImageToShow] = useState(img1);
    const [esAniversario, setEsAniversario] = useState(false);
    const [loading, setLoading] = useState(true);
    const [activo, setActivo] = useState('Servicios');
    const [index, setIndex] = useState(palabras.indexOf('Servicios'));
    const productos = [
        { imagen: prod1, nombre: "Canastillas" },
        { imagen: prod3, nombre: "Remolques" },

    ];
    const [sliderIndex, setSliderIndex] = useState(0);

    const siguiente = () => {
        setSliderIndex((prev) => (prev + 1) % sliderServicios.length);
    };

    const anterior = () => {
        setSliderIndex((prev) => (prev - 1 + sliderServicios.length) % sliderServicios.length);
    };

    const sliderServicios = [
        {
            imagen: pren800,
            titulo: "ESTAMPADO METÁLICO",
            descripcion: "Procesamos piezas metálicas mediante prensas mecánicas que van desde las 60  hasta las 800 toneladas, transformando materiales en componentes funcionales que cumplen con los requerimientos específicos de cada cliente e industria."
        },
        {
            imagen: manual,
            titulo: "SOLDADURA MANUAL Y ROBOTIZARA",
            descripcion: "Realizamos uniones metálicas utilizando procesos MIG y TIG, tanto de forma manual como con brazos robóticos, garantizando en cada ensamble altos estándares de calidad, resistencia y repetibilidad."
        },

        {
            imagen: zincado,
            titulo: "ZINCADO ELECTROLITICO",
            descripcion: "Aplicamos recubrimientos anticorrosivos mediante procesos en línea de colgado o barril, brindando protección efectiva contra la oxidación en piezas metálicas de distintas dimensiones."
        },
        {
            imagen: laser,
            titulo: "CORTE LÁSER",
            descripcion: "Realizamos cortes de alta precisión en lámina metálica, con excelente acabó en borde y flexibilidad en diseño para piezas personalizadas o producción en serie."
        },
        {
            imagen: cortetub,
            titulo: "CORTE DE TUBERÍA Y PERFILES.",
            descripcion: "Ejecutamos cortes automáticos y precisos en tubería y perfiles metálicos, optimizando tiempos de producción y garantizando acabados limpios para su integración en procesos posteriores."
        },
        {
            imagen: doblatubo,
            titulo: "DOBLEZ DE TUBERÍA Y LÁMINA.",
            descripcion: "Realizamos doblez de tubo y lámina con maquinaria CNC, obteniendo formas precisas en producción en serie que se adaptan a las especificaciones del cliente y a los estándares del producto final."
        },
        {
            imagen: prod3,
            titulo: "DISEÑO Y FABRICACIÓN DE REMOLQUES.",
            descripcion: "Desarrollamos remolques metálicos industriales a la medida, robustos y funcionales, listos para operar en tareas de transporte, carga o logística interna."
        },
        {
            imagen: raks,
            titulo: "DISEÑO Y FABRICACIÓN DE RAKS y Contenedores.",
            descripcion: "Fabricamos racks metálicos personalizados para el manejo, organización y almacenamiento de piezas, optimizando espacios y facilitando procesos en planta, almacén o líneas de producción.  Diseñamos y producimos contenedores metálicos duraderos para logística interna, transporte de materiales o almacenamiento industrial, con enfoque en funcionalidad y resistencia."
        },

        {
            imagen: estruc,
            titulo: "DISEÑO Y FABRICACIÓN DE ESTRUCTURAS METÁLICAS.",
            descripcion: "Diseñamos y producimos contenedores metálicos duraderos para logística interna, transporte de materiales o almacenamiento industrial, con enfoque en funcionalidad y resistencia."
        },

        {
            imagen: lamina,
            titulo: "FABRICACIÓN DE LÁMINA R-101.",
            descripcion: "Fabricamos y suministramos lámina acanalada R-101, ideal para techos, muros y cubiertas en proyectos industriales y comerciales, ofreciendo resistencia, durabilidad y fácil instalación."
        }
    ];

    // Efecto Fondo 
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const index = Math.min(
                fondoSecuencial.length - 1,
                Math.floor(scrollTop / 500)
            );
            setImageToShow(fondoSecuencial[index]);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Aniversario
    useEffect(() => {
        const hoy = new Date();
        if (hoy.getDate() === 11 && hoy.getMonth() === 10) {
            setEsAniversario(true);
        }
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000); // puedes cambiar el tiempo si lo deseas
        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <div className="preloader">
                <img src={roseta} loading="lazy" alt="Cargando..." className="gif-preloader" />
            </div>
        );
    }

    return (
        <div className="inicio-container">
            {esAniversario && (
                <div className="fireworks-background" />
            )}

            <div className="fondo-global-nosotros" style={{ backgroundImage: `url(${imageToShow})` }}>
                <div className="capa-negra" />
            </div>

            <div className="barra-superior-completa">
                <div className="barra-superior">
                    <div className="horario-contacto">
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="#fbd301" className="bi bi-circle-fill" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg> Lun-Vie: 8:00 - 17:00</span>
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="#fbd301" className="bi bi-circle-fill" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg> 55 8854 5539</span>
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="#fbd301" className="bi bi-circle-fill" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8" /></svg> contacto@troqueladosmodulares.com.mx</span>
                    </div>
                </div>

                <div className="barra-logo-iconos">
                    <div className="logo-superior">
                        <Link to={'/'}>
                            <img loading="lazy" src={logo} alt="Logo" />
                        </Link>
                    </div>
                    <div className="iconos">
                        <a
                            href="https://wa.me/525643108583"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <span className="icono">
                                {/* WhatsApp */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="bi bi-whatsapp" viewBox="0 0 16 16">
                                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                                </svg>
                            </span>
                        </a>

                        <a href="tel:+525588545539">
                            <span className="icono">
                                {/* Teléfono */}
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="bi bi-phone-fill" viewBox="0 0 16 16">
                                    <path d="M3 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm6 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0" />
                                </svg>
                            </span>
                        </a>

                        <a
                            href="mailto:contacto@troqueladosmodulares.com.mx"
                            className="icono"
                            title="Enviar correo a contacto@troqueladosmodulares.com.mx"
                        >
                            {/* Correo */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="bi bi-envelope-fill" viewBox="0 0 16 16">
                                <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
                            </svg>
                        </a>

                        <span className="icono">
                            {/* Ubicación */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
                            </svg>
                        </span>
                    </div>
                </div>

                <nav className="navbar navbar-expand-lg custom-navbar">
                    <div className="container-fluid">
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav mx-auto">
                                <Link to={'/'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link active" href="#inicio">Inicio</a></li></Link>
                                <Link to={'/nosotros'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link" href="#nosotros">Nosotros</a></li></Link>
                                <Link to={'/servicios'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link" href="#servicios">Servicios</a></li></Link>
                                <Link to={'/certificaciones'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link">Certificaciones</a></li></Link>
                                <Link to={'/contacto'} style={{ textDecoration: 'none' }}><li className="nav-item"><a className="nav-link" href="#contacto">Contacto</a></li></Link>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>

            <div className="slider3d-container">
                <div className="slider3d-scene">
                    <div className="slider3d-carousel" style={{ transform: `rotateY(-${index * 120}deg)` }}>
                        {palabras.map((palabra, index) => (
                            <span
                                key={index}
                                onClick={() => setActivo(palabra)}
                                className={activo === palabra ? 'activo' : ''}
                            >
                                {palabra}
                            </span>
                        ))}
                    </div>
                </div>
            </div>

            <div className="selector-contenedor">
                {/* Palabras con flechas a los lados */}
                <div className="selector-navegacion">
                    {/* Flecha izquierda */}
                    <button
                        className="flecha"
                        onClick={() => {
                            const nuevoIndex = (index - 1 + palabras.length) % palabras.length;
                            setIndex(nuevoIndex);
                            setActivo(palabras[nuevoIndex]);
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-left-fill" viewBox="0 0 16 16">
                            <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z" />
                        </svg>
                    </button>

                    {/* Palabras */}
                    <div className="selector-palabras">
                        {palabras.map((palabra, i) => (
                            <span
                                key={palabra}
                                onClick={() => {
                                    setActivo(palabra);
                                    setIndex(i);
                                }}
                                className={activo === palabra ? 'activo' : ''}
                            >
                                {palabra}
                            </span>
                        ))}
                    </div>

                    {/* Flecha derecha */}
                    <button
                        className="flecha"
                        onClick={() => {
                            const nuevoIndex = (index + 1) % palabras.length;
                            setIndex(nuevoIndex);
                            setActivo(palabras[nuevoIndex]);
                        }}>

                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                    </button>
                </div>

                {/* Contenido según la pestaña activa */}
                <div className="contenido">
                    {activo === 'Productos' && (
                        <div className="productos-grid">
                            {productos.map((prod, i) => (
                                <div key={i} className="producto-item">
                                    <img loading="lazy" src={prod.imagen} alt={prod.nombre} />
                                    <p className="producto-nombre">{prod.nombre}</p>
                                </div>
                            ))}
                        </div>
                    )}

                    {activo === 'Servicios' && (
                        <div className="slider-servicios">
                            <div className="slider-img-con-flechas">
                                <div className="slider-img-wrapper">
                                    <img
                                        loading="lazy"
                                        src={sliderServicios[sliderIndex].imagen}
                                        alt="Servicio"
                                        className="slider-imagen"
                                    />
                                    <button className="flecha-slider izquierda" onClick={anterior}>‹</button>
                                    <button className="flecha-slider derecha" onClick={siguiente}>›</button>
                                </div>

                                <h3 className="slider-titulo">{sliderServicios[sliderIndex].titulo}</h3>
                                <p className="slider-descripcion">{sliderServicios[sliderIndex].descripcion}</p>
                                <div className="Service-video">
                                    <video
                                        src={vidservicios}
                                        autoPlay
                                        muted
                                        loop
                                        className="video-servicio"
                                    ></video>
                                </div>
                            </div>

                        </div>
                    )}

                    {activo === 'Equipo' && (
                        <div className="equipo-contenedor">
                            <h2 className="equipo-titulo">Especificaciones</h2>
                            <div className="equipo-grid">

                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={pren800} loading="lazy" alt="Máquina dobladora" />
                                            </div>
                                            <div className="flip-back">
                                                <img src={pre800} loading="lazy" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">PRENSA 800 TONS</p>
                                </div>

                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={pre150} loading="lazy" alt="PRENSA 150 TONS" />
                                            </div>
                                            <div className="flip-back">
                                                <img src={desc150} loading="lazy" alt="Descripción PRENSA 150 TONS" />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">PRENSA 150 TONS</p>
                                </div>

                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={prensa110} loading="lazy" alt="Prensa mecánica" />
                                            </div>
                                            <div className="flip-back">
                                                <img src={desc110} loading="lazy" alt="Descripción PRENSA 110 TONS" />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">PRENSA 110 TONS</p>
                                </div>

                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={pren75} loading="lazy" alt="" />
                                            </div>
                                            <div className="flip-back">
                                                <img src={desc75} loading="lazy" alt="Descripción PRENSA 75 TONS" />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">PRENSA 75 TONS</p>
                                </div>

                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={pren60} loading="lazy" alt="" />
                                            </div>
                                            <div className="flip-back">
                                                <img src={desc60} loading="lazy" alt="Descripción PRENSA 60 TONS" />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">PRENSA 60 TONS</p>
                                </div>
                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={pren63} loading="lazy" alt="" />
                                            </div>
                                            <div className="flip-back">
                                                <img src={desc63} loading="lazy" alt="Descripción PRENSA 63 TONS" />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">PRENSA 63 TONS</p>
                                </div>
                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={doblamina} loading="lazy" alt="" />
                                            </div>
                                            <div className="flip-back">
                                                <img src={cortcnc} loading="lazy" alt="Descripción PRENSA 200 TONS" />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">DOBLADORA CORTINA CNC</p>
                                </div>

                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={dobtubo} loading="lazy" alt="" />
                                            </div>
                                            <div className="flip-back">
                                                <img src={descort} loading="lazy" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">CORTADORA AUTOMÁTICA DE TUBO Y BARRAS DE ACERO</p>
                                </div>
                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={cortubo} loading="lazy" alt="" />
                                            </div>
                                            <div className="flip-back">
                                                <img src={descdob} loading="lazy" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">DOBLADORA DE TUBO CNC</p>
                                </div>
                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={lamina} loading="lazy" alt="" />
                                            </div>
                                            <div className="flip-back">
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">ROLADORA DE LAMINA R-101</p>
                                </div>
                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={cnchaas} loading="lazy" alt="" />
                                            </div>
                                            <div className="flip-back">
                                                <img src={deschaas} loading="lazy" alt="Descripción de CNC HAAS" />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">CNC HAAS ST 30Y LATHE</p>
                                </div>
                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={robot} loading="lazy" alt="" />
                                            </div>
                                            <div className="flip-back">
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">SOLDADURA ROBOTIZADA</p>
                                </div>
                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={laser} loading="lazy" alt="" />
                                            </div>
                                            <div className="flip-back">
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">CORTE LÁSER</p>
                                </div>

                                <div className="equipo-item">
                                    <div className="flip-card">
                                        <div className="flip-inner">
                                            <div className="flip-front">
                                                <img src={metalera} loading="lazy" alt="" />
                                            </div>
                                            <div className="flip-back">
                                                <img src={geka} loading="lazy" alt="Descripción de CNC HAAS" />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="equipo-nombre">METALERA GEKA BENDICROP85S</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <br />
            <div>
                <Link to={'/contacto'}>
                    <button className='cotizar'>
                        <strong>COTIZAR  AHORA</strong>
                    </button>
                </Link>
            </div>

            <footer className="footer">
                <div className="footer-top">
                    <p>55 8854 5539</p>
                </div>
                <div className="footer-content">
                    {/* Columna izquierda */}
                    <div className="footer-left">
                        <p>contacto@troqueladosmodulares.com.mx</p>
                        <p>Carretera México - Querétaro Km. 100, Jilotepec Edo. Méx.</p>
                        <img src={logo} loading="lazy" alt="Logo" className="footer-logo" />
                        <img src={esr} loading="lazy" alt="Logo" className="footer-logo" />
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                            <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '20px' }} width="50" height="50" fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                            <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
                        </svg>
                    </div>

                    {/* Columna derecha */}
                    <div className="footer-right">
                        <p>  <a
                            href={aviso}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ cursor: "pointer", textDecoration: "none", color: "inherit" }}
                        >
                            Aviso de privacidad
                        </a></p>
                        <p>  <a
                            href={termino}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ cursor: "pointer", textDecoration: "none", color: "inherit" }}
                        >
                            Términos y Condiciones
                        </a></p>                        <p><a href="/contacto">Contáctanos</a></p>
                        <p>&copy; Troquelados modulares 2019</p>
                    </div>
                </div>
            </footer>

            <div style={{ height: '100%' }}></div>
        </div>
    );
};

export default Servicios;